import { useCallback, useState } from "react"

import type { ChartClickData } from "../widgets/types/chart"

export interface DashboardTableCellDrillDownSelection {
  baselineId?: string
  clickData: ChartClickData
  conversationsHref: string | null
}

export const useDashboardTableCellDrillDown = () => {
  const [selection, setSelection] =
    useState<DashboardTableCellDrillDownSelection | null>(null)

  const open = useCallback(
    (
      clickData: ChartClickData,
      conversationsHref: string | null,
      baselineId?: string,
    ) => {
      setSelection({ clickData, conversationsHref, baselineId })
    },
    [],
  )
  const close = useCallback(() => setSelection(null), [])

  return { selection, open, close }
}
